<template>
  <div>
    <ul class="list-unstyled rates-additional-info">
      <li
        v-for="(opt, i) in row.flatMap(r => r.rateData.rate.optional)"
        :key="i"
      >
        <mdb-icon
          :icon="determineIcon(opt)"
          :class="determineIconClass(opt)"
        />
        <bridge8-popover
          header-prefix="Optional Rate: "
          trigger="click"
          :text-callback="obj => obj.type"
          :fields="['type']"
          :obj="opt.rate && {type: opt.rate.type}"
        />
        <span class="price-display" v-if="opt.price.display">
          &nbsp;{{ opt.price.display }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mdbIcon } from 'mdbvue'
import Bridge8Popover from './Bridge8Popover'

export default {
  name: 'CalcRatesTableCellOptional',
  props: {
    row: {
      type: Array,
      required: true
    },
    selectedOptionalTypes: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    determineIcon (opt) {
      if (opt.price && (opt.price.amount === null)) return 'exclamation'
      if (opt.rate && this.selectedOptionalTypes.includes(opt.rate.type)) return 'check'
      if (opt.rate) return 'times'
    },
    determineIconClass (opt) {
      if (opt.price && (opt.price.amount === null)) return 'text-danger'
      if (opt.rate && this.selectedOptionalTypes.includes(opt.rate.type)) return 'text-success'
      if (opt.rate) return 'text-warning'
    }
  },
  components: {
    mdbIcon,
    Bridge8Popover
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellOptional.vue